/**
 * variant-gallery-reorder.js
 *
 * Quando uma variant é selecionada na PDP, marca a célula da `featured_media`
 * dela com `data-featured-variant="true"` (e remove de qualquer outra célula
 * que tinha a marcação antes). O reorder visual é feito 100% via CSS:
 *
 *   - Em desktop + layout grid: regra `order: -1` joga a célula marcada
 *     pra primeira posição visual. Sem mover DOM.
 *   - Não alterei nada pro mobile porque já está funcional
 */
(function () {
  if (window.__variantGalleryReorderInit) return;
  window.__variantGalleryReorderInit = true;

  function findGalleryForForm(formId) {
    if (formId) {
      const byForm = document.querySelector(`product-gallery[form="${formId}"]`);
      if (byForm) return byForm;
    }
    return document.querySelector('product-gallery');
  }

  function setFeaturedCell(gallery, mediaId) {
    if (!gallery || !mediaId) return;

    const stringId = String(mediaId);
    const target = gallery.querySelector(
      `.product-gallery__media[data-media-id="${stringId}"]`
    );
    if (!target) return;

    // Remove a marcação de qualquer célula anterior dessa galeria
    gallery
      .querySelectorAll('.product-gallery__media[data-featured-variant]')
      .forEach((el) => {
        if (el !== target) el.removeAttribute('data-featured-variant');
      });

    // Marca img de variant selecionada com o attributo que dispara o CSS
    target.setAttribute('data-featured-variant', 'true');
  }

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    const featured = variant && variant.featured_media;
    if (!featured || !featured.id) return;

    const formId =
      (event.target && event.target.id) ||
      (event.detail.form && event.detail.form.id);

    const gallery = findGalleryForForm(formId);
    setFeaturedCell(gallery, featured.id);
  });
})();
